export default [
  {
    path: 'materials',
    name: 'materials-menu',
    component: () => import('@/views/Pei.vue'),
    children: [
      {
        path: '',
        name: '',
        component: () =>
          import('@/views/pei/materialsEquipmentRequest/Wrapper.vue'),
        children: [
          {
            path: '/pei/materialsandequipmentrequest',
            name: 'Main',
            component: () =>
              import('@/views/pei/materialsEquipmentRequest/Main.vue'),
          },
        ],
      },
      {
        path: '/pei/materialsandequipmentrequest/add/:requestId?',
        name: 'materialAddRequest',
        props: ({ params }) => ({
          requestId: +params.requestId || 0,
        }),
        component: () =>
          import('@/views/pei/materialsEquipmentRequest/MaterialRequest.vue'),
      },
      {
        path: '',
        name: '',
        component: () =>
          import('@/views/pei/materialsEquipmentCatalog/Wrapper.vue'),
        children: [
          {
            path: '/pei/materialsandequipmentcatalog',
            name: 'Main',
            component: () =>
              import('@/views/pei/materialsEquipmentCatalog/Main.vue'),
          },
        ],
      },
      {
        path:
          '/pei/materialsandequipmentcatalog/edit/:classroomTypeId/:categoryId',
        name: 'materialEditCatalog',
        component: () =>
          import(
            '@/views/pei/materialsEquipmentCatalog/components/EditCatalog/Index.vue'
          ),
      },
      {
        path: '',
        name: '',
        component: () =>
          import('@/views/pei/materialsEquipmentRequisition/Wrapper.vue'),
        children: [
          {
            path: '/pei/materialsandequipmentrequisitionhandling',
            name: 'Main',
            component: () =>
              import('@/views/pei/materialsEquipmentRequisition/Main.vue'),
          },
        ],
      },
      {
        path: '/pei/materialsEquipmentrequisition/:requestId?',
        name: 'materialAddRequisition',
        component: () =>
          import(
            '@/views/pei/materialsEquipmentRequisition/AddRequisition/Main.vue'
          ),
      },
    ],
  },
];
